// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-label {
  text-align: right;
  padding-right: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared-components-module/resident-data/resident-data.component.less"],"names":[],"mappings":"AAAA;EACI,iBAAA;EACA,mBAAA;AACJ","sourcesContent":[".form-label {\n    text-align: right;\n    padding-right: 20px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
